import { LOGGED_IN_USERS_ONLY } from '$lib/services/auth/policies';
import { LOGIN_EXCEPTION_HANDLER } from '$lib/services/auth/policy-exception-handler';

export const policy = LOGGED_IN_USERS_ONLY;
export const policyExceptionHandler = LOGIN_EXCEPTION_HANDLER;
